import React, { useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { compose } from 'redux';
import classnames from 'classnames';
import { createStructuredSelector } from 'reselect';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { Grid } from '@material-ui/core';
import { Input, Button, Form, H1, F } from 'components/Ui';
import { validatePassword } from 'utils/formValidators';
import { createPassword } from 'containers/CheckoutPage/actions';
import { selectCartSummary } from 'containers/Cart/selectors';

import styles from './styles.scss';

const ChangePasswordForm = ({ summary }) => {
  const dispatch = useDispatch();
  const [createPasswordString, setCreatePasswordString] = useState('');
  const [confirmPasswordString, setConfirmPasswordString] = useState('');
  const [showCreatePasswordString, setShowCreatePasswordString] = useState(
    false,
  );
  const [showConfirmPasswordString, setShowConfirmPasswordString] = useState(
    false,
  );

  const handleCreatePasswordStringChange = (event) => {
    setCreatePasswordString(event.target.value);
  };

  const handleConfirmPasswordStringChange = (event) => {
    setConfirmPasswordString(event.target.value);
  };

  const handleSubmit = () => {
    dispatch(
      createPassword({
        cartId: summary.id,
        password: createPasswordString,
      }),
    );
  };

  ValidatorForm.addValidationRule('same', () => {
    if (createPasswordString) {
      return createPasswordString === confirmPasswordString;
    }
    return true;
  });

  const passwordValidations = validatePassword(createPasswordString);

  return (
    <Form className={styles.container}>
      <Grid container spacing={4} className={styles.form}>
        <Grid className={styles.titleContainer} item xs={12} md={12}>
          <H1 className={styles.title}>Create your password</H1>
        </Grid>
        <Grid className={styles.label} item sm={12} md={6}>
          <Input
            label="Create Password"
            validators={['required', 'password']}
            errorMessages={[
              'Create Password is required',
              'Password is not valid',
            ]}
            value={createPasswordString}
            onChange={handleCreatePasswordStringChange}
            name="createPasswordString"
            type={showCreatePasswordString ? 'text' : 'password'}
            rightComp={
              <Button
                text={showCreatePasswordString ? 'Hide' : 'Show'}
                onClick={() =>
                  setShowCreatePasswordString(!showCreatePasswordString)
                }
                link
                bold
              />
            }
          />
        </Grid>
        <Grid className={styles.label} item sm={12} md={6}>
          <Input
            disabled={!passwordValidations.validPassword}
            label="Confirm Password"
            validators={['required', 'same']}
            errorMessages={[
              'Confirm Password is required',
              'Create and Confirm Passwords must be the same',
            ]}
            value={confirmPasswordString}
            onChange={handleConfirmPasswordStringChange}
            name="confirmPasswordString"
            type={showConfirmPasswordString ? 'text' : 'password'}
            rightComp={
              <Button
                text={showConfirmPasswordString ? 'Hide' : 'Show'}
                onClick={() =>
                  setShowConfirmPasswordString(!showConfirmPasswordString)
                }
                link
                bold
              />
            }
          />
        </Grid>
        {createPasswordString && (
          <div className={styles.hints}>
            <div>
              <span
                className={classnames(styles.needsRequirment, {
                  [styles.hasRequirment]: passwordValidations.hasAtLeast8Chars,
                })}
              >
                X
              </span>{' '}
              <F>Must contain at least 8 characters</F>
            </div>
            <div className={styles.combineRequirment}>
              <span
                className={classnames(styles.needsRequirment, {
                  [styles.hasRequirment]:
                    passwordValidations.hasMixofLettersNumbers,
                })}
              >
                X
              </span>{' '}
              <span
                className={classnames({
                  [styles.meetsRequirment]:
                    passwordValidations.hasMixofLettersNumbers,
                })}
              >
                <F>Must contain at least 3 of the following</F>
              </span>
            </div>
            <div>
              <span
                className={classnames(styles.needsRequirment, {
                  [styles.hasRequirment]:
                    passwordValidations.hasAtLeastOneLowerCase,
                })}
              >
                X
              </span>{' '}
              <F>Lower case letters (a-z)</F>
            </div>
            <div>
              <span
                className={classnames(styles.needsRequirment, {
                  [styles.hasRequirment]:
                    passwordValidations.hasAtLeastOneUpperCase,
                })}
              >
                X
              </span>{' '}
              <F>Upper case letters (A-Z)</F>
            </div>
            <div>
              <span
                className={classnames(styles.needsRequirment, {
                  [styles.hasRequirment]:
                    passwordValidations.hasAtLeastOneDigit,
                })}
              >
                X
              </span>{' '}
              <F>Numbers (0-9)</F>
            </div>
            <div>
              <span
                className={classnames(styles.needsRequirment, {
                  [styles.hasRequirment]:
                    passwordValidations.hasAtLeastOneSpecialChar,
                })}
              >
                X
              </span>{' '}
              <F>Special characters (e.g. !@#$%^&*)</F>
            </div>
          </div>
        )}
        <Grid className={styles.buttons} item xs={12} md={12}>
          <Button
            text="Create Password"
            className={styles.submit}
            disabled={
              !passwordValidations.validPassword ||
              createPasswordString !== confirmPasswordString
            }
            onClick={handleSubmit}
            // loading={isRestorePasswordFetching}
          />
        </Grid>
      </Grid>
    </Form>
  );
};

const mapStateToProps = createStructuredSelector({
  summary: selectCartSummary(),
});

export default compose(connect(mapStateToProps))(ChangePasswordForm);
